"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LOGIN_ERRORS;
(function (LOGIN_ERRORS) {
    LOGIN_ERRORS["USER_NOT_EXISTS"] = "USER_NOT_EXISTS";
    LOGIN_ERRORS["NO_TOKEN_PROVIDED"] = "NO_TOKEN_PROVIDED";
    LOGIN_ERRORS["INVALID_TOKEN"] = "INVALID_TOKEN";
})(LOGIN_ERRORS = exports.LOGIN_ERRORS || (exports.LOGIN_ERRORS = {}));
